import { TealiumPromoList } from '@woolworthsnz/styleguide';

export const getAnalyticsData = (visibleItems: any[]): TealiumPromoList =>
	visibleItems.reduce((promoList: TealiumPromoList, item: any, currentIndex: number) => {
		promoList.media_label[currentIndex] = `${item.name}`;
		promoList.media_category[currentIndex] = `${item.imagePath}`;
		promoList.media_carousel_slot[currentIndex] = `${currentIndex + 1}`;
		promoList.media_carousel_slot[currentIndex] = `${currentIndex + 1}`;
		promoList.media_destination_link[currentIndex] = `${item.link}`;
		return promoList;
	}, new TealiumPromoList());
